import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },
  fetchHarvestedBatches(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/fetch_harvested_batches/${harvest_process_id}`
    );
  },
  downloadRepHarvestXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/download_rep_harvest_xlsx/${harvest_process_id}`,
      { responseType: "blob" }
    );
  },
  downloadRepPackingXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/download_rep_packing_xlsx/${harvest_process_id}`,
      { responseType: "blob" }
    );
  },
  downloadRepConsolidatedXlsx(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/download_rep_consolidated_xlsx/${harvest_process_id}`,
      { responseType: "blob" }
    );
  }
};
